var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('GChart',{ref:"chart",attrs:{"settings":{
    packages: ['sankey'],
  },"type":"Sankey","data":_vm.sankeyData,"options":_vm.sankeyOptions,"events":_vm.chartEvents}})}
var staticRenderFns = []

export { render, staticRenderFns }